import { Component, Input } from '@angular/core';
import { LocaleService } from '@markant-platform/shared/util-locale';
import { formatAddress } from '@markant-platform/shared/organization/util';
import { TranslocoService } from '@jsverse/transloco';
import { OrganizationDetailData } from 'data-model';

@Component({
  selector: 'markant-platform-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss', '../shared-organization.scss'],
})
export class OrganizationDetailsComponent {
  @Input() organization!: OrganizationDetailData;
  @Input() userCount?: number;
  @Input() documentCount?: number;

  @Input() isPlatformAdmin: boolean | null = false;

  protected readonly formatAddress = formatAddress;

  get commercialRegister(): string | undefined {
    const { commercialRegister, commercialRegisterId } = this.organization;
    if (!commercialRegister && !commercialRegisterId) {
      return undefined;
    }
    return [commercialRegister, commercialRegisterId].filter(Boolean).join(' ');
  }

  constructor(
    readonly translocoService: TranslocoService,
    readonly localeService: LocaleService
  ) {}
}
